import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from "@angular/router";

@Injectable()
export class RfViewerUserGuard implements CanActivate, CanActivateChild {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkAccess(state.url);
  }

  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkAccess(state.url);
  }

  private checkAccess(url: string): boolean {
    const storedProfile = window.localStorage.getItem("userProfile");
    if (!storedProfile) {
      return true;
    }

    let userProfile: any;
    try {
      userProfile = JSON.parse(storedProfile);
    } catch (e) {
      return true;
    }

    // only lock RF Viewer
    if (!userProfile || userProfile.role !== "RF Viewer") {
      return true;
    }

    const path = (url || "").split("?")[0];
    // allowed: reservations list + reservation view
    if (
      path === "/pages/reservations" ||
      path.startsWith("/pages/project/view-reservation")
    ) {
      return true;
    }

    this.router.navigate(["/pages/reservations"]);
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/rf-viewer-user.guard.ts